<div class="scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button (click)="scrollToTop()">
    <i class="fas fa-arrow-circle-up"></i>
  </button>
</div>
